// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Regex from "../../../../utils/Regex.bs.js";
import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as NextButton from "../../../library/NextButton.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as FormHelpers from "../../../../utils/FormHelpers.bs.js";
import * as ReactHookForm from "../../../../bindings/ReactHookForm.bs.js";
import * as PreviousButton from "../../../library/PreviousButton.bs.js";
import * as SignUpStepStyles from "./SignUpStepStyles.bs.js";
import * as LayoutDataContext from "../../../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeePublicClient from "../../../../api/PrezzeePublicClient.bs.js";
import * as RichText$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js";
import * as TextField$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js";

var make = React.memo(function (props) {
      var state = props.state;
      var dispatch = props.dispatch;
      var onNextBtnClick = props.onNextBtnClick;
      var onPreviousBtnClick = props.onPreviousBtnClick;
      var layoutData = LayoutDataContext.useContext(undefined);
      var registerData = Belt_Option.flatMap(layoutData, (function (o) {
              return o.register;
            }));
      var stepTitlePassword = Belt_Option.mapWithDefault(registerData, "<p>Awesome!</p><p>Choose a secure password which:</p>", (function (c) {
              return c.stepTitlePassword;
            }));
      var passwordRequirements = Belt_Option.mapWithDefault(registerData, "\n      <ul>\n        <li>\n          Has a minimum 8 characters\n        </li>\n        <li >\n          Has at least one lower case letter\n        </li>\n        <li>\n          Has at least one upper case letter\n        </li>\n        <li>\n          Has at least one digit\n        </li>\n      </ul>", (function (c) {
              return c.passwordRequirements;
            }));
      var passwordLabel = Belt_Option.mapWithDefault(registerData, "Password", (function (c) {
              return c.passwordLabel;
            }));
      var passwordRequiredText = Belt_Option.mapWithDefault(registerData, "Password is required", (function (c) {
              return c.passwordRequiredText;
            }));
      var invalidPasswordText = Belt_Option.mapWithDefault(registerData, "Please retry with a more secure password. (Max: 100 Characters)", (function (c) {
              return c.invalidPasswordText;
            }));
      var passwordInput = {
        required: {
          value: true,
          message: passwordRequiredText
        },
        pattern: {
          value: Regex.passwordRegex,
          message: invalidPasswordText
        }
      };
      var form = ReactHookForm.useForm({
            mode: "all",
            defaultValues: {
              password: props.statePassword
            }
          }, undefined);
      var onSubmit = React.useCallback((function (data) {
              var password = FormHelpers.getValue(data.password);
              if (password !== "") {
                Curry._1(dispatch, {
                      TAG: /* Step3Update */2,
                      password: password
                    });
              }
              Js_promise.then_((function (data) {
                      if (data.TAG === /* Ok */0) {
                        return Promise.resolve(Curry._1(onNextBtnClick, undefined));
                      }
                      var e = data._0;
                      switch (e.TAG | 0) {
                        case /* NetworkError */0 :
                        case /* JsonParsingError */1 :
                            return Promise.resolve(Curry._2(form.setError, "password", {
                                            type: "manual",
                                            message: "Unexpected error, please try again later"
                                          }));
                        case /* ServerError */2 :
                            var serverError = e._0;
                            if (typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */0) {
                              return Promise.resolve(Curry._2(form.setError, "password", {
                                              type: "manual",
                                              message: "Unexpected error, please try again later"
                                            }));
                            } else {
                              return Promise.resolve(Curry._2(form.setError, "password", {
                                              type: "manual",
                                              message: Belt_Option.getWithDefault(Belt_Array.get(serverError._0.split("Password: "), 1), "This password is too common.")
                                            }));
                            }
                        
                      }
                    }), PrezzeePublicClient.validateCustomerPassword({
                        firstName: Belt_Option.getWithDefault(Caml_option.nullable_to_opt(state.firstName), ""),
                        lastName: Belt_Option.getWithDefault(Caml_option.nullable_to_opt(state.lastName), ""),
                        email: Belt_Option.getWithDefault(Caml_option.nullable_to_opt(state.email), ""),
                        password: password
                      }));
            }), [dispatch]);
      return JsxRuntime.jsxs("form", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                children: stepTitlePassword
                              }),
                          className: SignUpStepStyles.formLabel
                        }),
                    JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                          children: passwordRequirements,
                          className: Cn.make([
                                SignUpStepStyles.list,
                                "w-full text-left pl-5 mb-8"
                              ])
                        }),
                    JsxRuntime.jsx(TextField$PrezzeeRibbon.make, {
                          autoFocus: true,
                          className: SignUpStepStyles.formInput_,
                          label: passwordLabel,
                          name: "password",
                          type_: "password",
                          error: Belt_Option.isSome(FormHelpers.getError(form.formState.touched, "password", form.errors)),
                          helperText: Belt_Option.getWithDefault(FormHelpers.getError(form.formState.touched, "password", form.errors), ""),
                          inputRef: Caml_option.some(Curry._1(form.register, passwordInput))
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(PreviousButton.make, {
                                  onClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* Step3Update */2,
                                            password: FormHelpers.getValue(Curry._1(form.getValues, undefined).password)
                                          });
                                      Curry._1(onPreviousBtnClick, undefined);
                                    }),
                                  className: SignUpStepStyles.previousButton
                                }),
                            JsxRuntime.jsx(NextButton.make, {
                                  className: form.formState.isValid ? SignUpStepStyles.nextButton : SignUpStepStyles.nextButtonDisabled,
                                  isDisabled: !form.formState.isValid,
                                  type_: "submit"
                                })
                          ],
                          className: "flex items-center justify-between"
                        })
                  ],
                  onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                });
    });

export {
  make ,
}
/* make Not a pure module */
